import { applicationConfiguration } from 'app/modules/shared'
import React, { useContext } from 'react'
import { useDropzone } from 'react-dropzone'

interface FilePickerProps {
  children?: any
  onDrop: (files: File[]) => void
}

/**
 * FilePicker component.
 * Allows you to select files on hard drive or drag&drop.
 */
export const FilePicker = ({ children, onDrop }: FilePickerProps): JSX.Element => {
  const config = useContext(applicationConfiguration)
  const isScanBlocked = config.maintenance.blockScan
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, disabled: isScanBlocked })

  return (
    <div
      className={`file-picker-container${isScanBlocked ? ' disabled' : ''}${isDragActive ? ' dragover' : ''}`}
      onDragOver={(e) => e.preventDefault()}
      {...getRootProps()}
    >
      <input {...getInputProps()} />
      {children}
    </div>
  )
}
